var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-progress"
  }, [_c('el-progress', _vm._g(_vm._b({
    style: _vm.styleWidth,
    attrs: {
      "type": _vm.type || 'line'
    }
  }, 'el-progress', { ..._vm.$attrs,
    ..._vm.obj
  }, false), _vm.$listeners)), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };